import { HomeLayout } from '../layout';
import Home from '../pages/home-page';
//import LogReport from '../components/Comingsoon';
//import EquipmentCheckComingsoon from '../components/EquipmentCheckComingsoon';
import Admin from '../pages/admin/asset-management';
//import UserManagement from '../pages/userManagement/UserManagement'
import AdminPage from '../pages/admin/index';
import WebpageMsg from '../components/WebpageMsg';
import Technical from '../pages/technical/Technical';
import HeatProfile from '../components/HeatProfile';
import AnalysisPage from '../pages/analysis/index';
//import TechnicalPage from '../components/CRCE Technical/TechnicalPage';
import TechnicalReportPage from '../components/CRCE Technical/TechnicalReportPage';
import DcalPage from '../components/DCAL/DcalPage';
import TechnicalPageAgGrid from '../components/CRCE Technical/TechnicalPageAgGrid';
import TechnicalPDFViewer from '../components/CRCE Technical/TechnicalPDFViewer';
import DocControl from '../pages/technical/DocControl';
//import Calibration from '../components/Calibration/Calibration';
//import CalibrationPageAgGrid from '../components/Calibration/CalibrationPageAgGrid';
import CalibrationMainPage from '../components/Calibration/CalibrationMainPage';
import AssistancePage from '../components/Assistance/AssistancePage';
import HeatProfilePDFViewer from '../components/Heatprofile/HeatProfilePDFViewer';
import ProjectHeatProfilePDFViewer from '../components/Heatprofile/ProjectHeatProfilePDFViewer';
import HeatProfileImageViewer from '../components/Heatprofile/HeatProfileImageViewer';

export default [
  {
    path: '/',
    exact: true,
    layout: HomeLayout,
    component: Home,
  },

  {
    path: '/dashboard',
    layout: HomeLayout,
    component: Home,
  },

  {
    path: '/log-report',
    layout: HomeLayout,
    component: AnalysisPage,
  },

  {
    path: '/asset-management',
    layout: HomeLayout,
    component: Admin,
  },

  {
    path: '/admin',
    layout: HomeLayout,
    component: AdminPage,
  },

  {
    path: '/web-page',
    layout: HomeLayout,
    component: WebpageMsg,
  },

  {
    path: '/technical',
    layout: HomeLayout,
    component: Technical,
  },
  {
    path: '/calibration-control',
    layout: HomeLayout,
    component: DocControl,
  },

  {
    path: '/heat-profile',
    layout: HomeLayout,
    component: HeatProfile,
  },
  {
    path: '/calibration',
    layout: HomeLayout,
    component: CalibrationMainPage,
  },

  {
    path: '/TechnicalPage',
    exact: true,
    layout: HomeLayout,
    component: TechnicalPageAgGrid,
  },
  {
    path: '/TechnicalPage/pdf/:id',
    layout: HomeLayout,
    component: TechnicalPDFViewer,
  },
  {
    path: '/heat-profile/pdf/:id',
    layout: HomeLayout,
    component: HeatProfilePDFViewer,
  },
  {
    path: '/project-heat-profile/pdf/:id',
    layout: HomeLayout,
    component: ProjectHeatProfilePDFViewer,
  },
  {
    path: '/heat-profile/image/:id',
    layout: HomeLayout,
    component: HeatProfileImageViewer,
  },
  {
    path: '/TechnicalTestPage',
    layout: HomeLayout,
    component: TechnicalReportPage,
  },
  {
    path: '/DCALGenerator',
    layout: HomeLayout,
    component: DcalPage,
  },
  {
    path: '/AskEvans',
    layout: HomeLayout,
    component: AssistancePage,
  },
  // {
  //   path: '/DCAlUpdatePage',
  //   layout: HomeLayout,
  //   component: DcalUpdateForm,
  // }
  // {
  //   path: '/maintenance-history',
  //   layout: HomeLayout,
  //   component: Home,
  // },
];
